import { ACCESS_TOKEN_KEY } from '../config'
import { getLocalItem, setLocalItem, removeLocalItem } from './storage'

export const isLogin = () => {
  return getLocalItem(ACCESS_TOKEN_KEY)
}

export const setLogin = (token) => {
  return setLocalItem(ACCESS_TOKEN_KEY, token)
}

export const setLogOut = () => {
  return removeLocalItem(ACCESS_TOKEN_KEY)
}
